@if (
  ('portal_services_operational_status' | featureFlagPure | async) &&
  service?.operationalStatus
) {
  <span
    class="badge rounded-pill ms-2"
    [class]="operationalStatusBgColor"
    nz-tooltip
    [nzTooltipTitle]="tooltipTitle | translate"
    [nzTooltipColor]="'#fff'"
  >
    <span class="fw-normal">
      {{
        'service.operational_status.' + service.operationalStatus | translate
      }}
    </span>
  </span>
}

@if (service?.activityStatus) {
  <span class="badge rounded-pill ms-2" [class]="activityStatusBgColor">
    <span class="fw-normal">
      {{
        ServiceActivityStatusTranslationMap[service.activityStatus] | translate
      }}
    </span>
  </span>
}
